import { getTranslation } from "@/locales/translations"

export default {
    methods: {
        __(phrase) {
            return getTranslation(phrase, this.$store.state.lang) || phrase
        }
    }
}
